import React from "react";
import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { Link } from "react-router-dom";

export default function Footer() {
  const { site } = useSite();
  return (
    <footer data-testid="site-footer" className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            {site?.logo_url && (
              <img
                src={site.logo_url}
                alt={site?.business_name}
                className="h-20 w-auto bg-white p-2"
              />
            )}
            <h3 className="mt-6 font-heading text-2xl font-bold uppercase tracking-tight">
              {site?.business_name || "J&S Complete Remodeling Inc"}
            </h3>
            <p className="mt-3 text-neutral-400 max-w-md">
              Kitchen, bath, and full-home remodeling in Chicagoland. Quality work,
              fair prices, and a crew that treats your home like their own.
            </p>
          </div>

          <div>
            <h4 className="font-heading uppercase text-sm tracking-widest text-[#DC2626] mb-4">
              Contact
            </h4>
            <ul className="space-y-3 text-sm text-neutral-300">
              <li className="flex items-start gap-2">
                <Phone size={16} className="text-[#DC2626] mt-0.5 flex-shrink-0" />
                <a href={`tel:${site?.phone_raw}`} className="hover:text-white">
                  {site?.phone}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={16} className="text-[#DC2626] mt-0.5 flex-shrink-0" />
                <a href={`mailto:${site?.email}`} className="hover:text-white break-all">
                  {site?.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={16} className="text-[#DC2626] mt-0.5 flex-shrink-0" />
                <span>{site?.service_area}</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading uppercase text-sm tracking-widest text-[#DC2626] mb-4">
              Services
            </h4>
            <ul className="space-y-2 text-sm text-neutral-300">
              {(site?.services || []).slice(0, 6).map((s) => (
                <li key={s.id}>
                  <a href="#services" className="hover:text-white transition-colors">
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-neutral-800 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <p className="text-xs text-neutral-500">
            © {new Date().getFullYear()} {site?.business_name || "J&S Complete Remodeling Inc"}. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            {site?.facebook && (
              <a href={site.facebook} target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-[#DC2626]">
                <Facebook size={20} />
              </a>
            )}
            {site?.instagram && (
              <a href={site.instagram} target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-[#DC2626]">
                <Instagram size={20} />
              </a>
            )}
            <Link
              data-testid="footer-admin-link"
              to="/admin/login"
              className="text-xs text-neutral-600 hover:text-neutral-300 uppercase tracking-widest"
            >
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
